import React, { useState, useEffect, useMemo } from "react";
import { Button, Table, Spinner, Modal } from "react-bootstrap";
import {
  useTable,
  usePagination,
  useGlobalFilter,
  useSortBy,
} from "react-table";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useDispatch } from "react-redux";
import { Fn_FillListData } from "../../store/Functions";

const DriverForApproval = () => {
  const [state, setState] = useState({});
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageModal, setImageModal] = useState({ show: false, url: "", label: "" });
  const [rowDates, setRowDates] = useState({}); // Store dates for each row: { rowId: { expiryDL, expiryInsurance, expiryPUC } }
  const dispatch = useDispatch();

  const API_URL = `${API_WEB_URLS.MASTER}/0/token/DriverForApproval`;
  const API_URL_DL = `${API_WEB_URLS.MASTER}/0/token/UpdateDLExpiry`;
  const API_URL_PUC = `${API_WEB_URLS.MASTER}/0/token/UpdatePUCExpiry`;
  const API_URL_Insurance = `${API_WEB_URLS.MASTER}/0/token/UpdateInsuranceExpiry`;
  const API_URL_Approval = `${API_WEB_URLS.MASTER}/0/token/ApproveDriver`;
useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
    const res =   await Fn_FillListData(
        dispatch,
        setGridData,
        "gridData",
        API_URL + "/Id/0"
      );
      console.log("Fetched driver data:", res);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [dispatch, API_URL]);

  // Initialize rowDates from fetched data
  useEffect(() => {
    if (gridData && gridData.length > 0) {
      const initialDates = {};
      gridData.forEach(row => {
        if (row.DLExpiryDate || row.InsuranceExpiryDate || row.PUCExpiryDate) {
          initialDates[row.Id] = {
            expiryDL: row.DLExpiryDate || '',
            expiryInsurance: row.InsuranceExpiryDate || '',
            expiryPUC: row.PUCExpiryDate || ''
          };
        }
      });
      setRowDates(initialDates);
    }
  }, [gridData]);

  const data = useMemo(() => gridData || [], [gridData]);

  const buildImageUrl = (imageName) => {
    if (!imageName) return "";
    return `${API_WEB_URLS.IMAGEURL}${imageName}`;
  };

  const handleApprovalClick = (rowData, isReject = false) => {
    const val = isReject ? 2 : 1;
    console.log(isReject ? "Reject row data:" : "Approval row data:", rowData);

    Fn_FillListData(
      dispatch,
      setState,
      "nothing",
      `${API_URL_Approval}/${val}/${rowData.Id}`
    ).finally(() => {
      // Refresh list after approve/reject
      Fn_FillListData(dispatch, setGridData, "gridData", API_URL + "/Id/0");
    });
  };

  // Function to convert date to SMS format (YYYY-MM-DD)
  const formatDateToSMS = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Handle Expiry DL Date Change
  const handleExpiryDLChange = (rowData, dateValue) => {
    const smsFormattedDate = formatDateToSMS(dateValue);
    console.log("Expiry DL - Row ID:", rowData.Id, "| Date:", smsFormattedDate);
    
    // Update state to track date for this row
    setRowDates(prev => ({
      ...prev,
      [rowData.Id]: {
        ...prev[rowData.Id],
        expiryDL: dateValue
      }
    }));
    
    Fn_FillListData(dispatch, setState, "gridData", API_URL_DL + `/${smsFormattedDate}/${rowData.Id}`);
  };

  // Handle Expiry Insurance Date Change
  const handleExpiryInsuranceChange = (rowData, dateValue) => {
    const smsFormattedDate = formatDateToSMS(dateValue);
    console.log("Expiry Insurance - Row ID:", rowData.Id, "| Date:", smsFormattedDate);
    
    // Update state to track date for this row
    setRowDates(prev => ({
      ...prev,
      [rowData.Id]: {
        ...prev[rowData.Id],
        expiryInsurance: dateValue
      }
    }));
    
    Fn_FillListData(dispatch, setState, "gridData", API_URL_Insurance + `/${smsFormattedDate}/${rowData.Id}`);
  };

  // Handle Expiry PUC Date Change
  const handleExpiryPUCChange = (rowData, dateValue) => {
    const smsFormattedDate = formatDateToSMS(dateValue);
    console.log("Expiry PUC - Row ID:", rowData.Id, "| Date:", smsFormattedDate);
    
    // Update state to track date for this row
    setRowDates(prev => ({
      ...prev,
      [rowData.Id]: {
        ...prev[rowData.Id],
        expiryPUC: dateValue
      }
    }));
    
    Fn_FillListData(dispatch, setState, "nothing", API_URL_PUC + `/${smsFormattedDate}/${rowData.Id}`);
  };
  
  const documentKeys = useMemo(
    () => [
      { key: "AadharFront", label: "Aadhar Front" },
      { key: "AadharBack", label: "Aadhar Back" },
      { key: "RcFront", label: "RC Front" },
      { key: "RCBack", label: "RC Back" },
      { key: "DrivingLicenseFront", label: "DL Front" },
      { key: "DrivingLicenseBack", label: "DL Back" },
      { key: "Insurance", label: "Insurance" },
      { key: "PUC", label: "PUC" },
    ],
    []
  );

  const columns = useMemo(
    () => {
      const baseColumns = [
      { Header: "Name", accessor: "Name", Cell: ({ value }) => <span style={{ fontSize: 12 }}>{value || "-"}</span> },
      { Header: "Father Name", accessor: "FatherName", Cell: ({ value }) => <span style={{ fontSize: 11 }}>{value || "-"}</span> },
      { Header: "Email", accessor: "Email", Cell: ({ value }) => <span style={{ fontSize: 11 }}>{value || "-"}</span> },
      { Header: "Mobile", accessor: "MobileNo", Cell: ({ value }) => <span style={{ fontSize: 11 }}>{value || "-"}</span> },
      { Header: "PAN", accessor: "PanNo", Cell: ({ value }) => <span style={{ fontSize: 11 }}>{value || "-"}</span> },
      { Header: "Aadhar", accessor: "AadharNo", Cell: ({ value }) => <span style={{ fontSize: 11 }}>{value || "-"}</span> },
      { Header: "DL", accessor: "DrivingLicence", Cell: ({ value }) => <span style={{ fontSize: 11 }}>{value || "-"}</span> },
      { Header: "Pincode", accessor: "Pincode", Cell: ({ value }) => <span style={{ fontSize: 11 }}>{value || "-"}</span> },
      ];

      const documentColumns = documentKeys.map((d) => ({
        Header: d.label,
        accessor: d.key, // value will be the image filename
        disableSortBy: true,
        Cell: ({ value }) => {
          if (!value) return <span className="text-muted">-</span>;
          const url = buildImageUrl(value);
          if (!url) return <span className="text-muted">-</span>;

          return (
            <div
              className="text-center"
              style={{ cursor: "pointer", minWidth: 52 }}
              onClick={() => setImageModal({ show: true, url, label: d.label })}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && setImageModal({ show: true, url, label: d.label })}
              title={`${d.label} - Click to view`}
            >
              <img
                src={url}
                alt={d.label}
                style={{
                  width: 40,
                  height: 40,
                  objectFit: "cover",
                  borderRadius: 4,
                  border: "1px solid #dee2e6",
                }}
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
            </div>
          );
        },
      }));

      const dateColumns = [
        {
          Header: "Expiry DL",
          id: "expiryDL",
          disableSortBy: true,
          Cell: ({ row }) => {
            const rowId = row.original.Id;
            const dateValue = rowDates[rowId]?.expiryDL || '';
            return (
              <input
                type="date"
                className="form-control form-control-sm"
                style={{ fontSize: 11, width: 130 }}
                value={dateValue}
                onChange={(e) => handleExpiryDLChange(row.original, e.target.value)}
              />
            );
          },
        },
        {
          Header: "Expiry Insurance",
          id: "expiryInsurance",
          disableSortBy: true,
          Cell: ({ row }) => {
            const rowId = row.original.Id;
            const dateValue = rowDates[rowId]?.expiryInsurance || '';
            return (
              <input
                type="date"
                className="form-control form-control-sm"
                style={{ fontSize: 11, width: 130 }}
                value={dateValue}
                onChange={(e) => handleExpiryInsuranceChange(row.original, e.target.value)}
              />
            );
          },
        },
        {
          Header: "Expiry PUC",
          id: "expiryPUC",
          disableSortBy: true,
          Cell: ({ row }) => {
            const rowId = row.original.Id;
            const dateValue = rowDates[rowId]?.expiryPUC || '';
            return (
              <input
                type="date"
                className="form-control form-control-sm"
                style={{ fontSize: 11, width: 130 }}
                value={dateValue}
                onChange={(e) => handleExpiryPUCChange(row.original, e.target.value)}
              />
            );
          },
        },
      ];

      const approvalColumn = {
        Header: "Action",
        id: "approval",
        disableSortBy: true,
        Cell: ({ row }) => {
          const rowId = row.original.Id;
          const dates = rowDates[rowId] || {};
          const isApproveDisabled = !dates.expiryDL || !dates.expiryInsurance || !dates.expiryPUC;
          
          return (
            <div style={{ display: "flex", gap: 4 }}>
              <Button 
                size="sm" 
                variant="outline-success" 
                className="py-0 px-1" 
                style={{ fontSize: 11 }} 
                onClick={() => handleApprovalClick(row.original, false)}
                disabled={isApproveDisabled}
                title={isApproveDisabled ? "Please fill all expiry dates" : ""}
              >
                Approve
              </Button>
              <Button size="sm" variant="outline-danger" className="py-0 px-1" style={{ fontSize: 11 }} onClick={() => handleApprovalClick(row.original, true)}>Reject</Button>
            </div>
          );
        },
      };

      return [...baseColumns, ...documentColumns, ...dateColumns, approvalColumn];
    },
    [documentKeys, rowDates]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, globalFilter },
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: { 
        pageIndex: 0, 
        pageSize: 10,
        sortBy: [
          {
            id: 'Name',
            desc: false
          }
        ]
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  if (loading) {
    return (
      <div style={{ padding: "6px 8px", display: "flex", justifyContent: "center", alignItems: "center", minHeight: 120 }}>
        <Spinner animation="border" size="sm" />
      </div>
    );
  }

  return (
    <div style={{ padding: "6px 8px", maxWidth: 1400, margin: "0 auto" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4, paddingBottom: 4, borderBottom: "1px solid #dee2e6" }}>
        <span style={{ fontSize: 13, fontWeight: 600, color: "#333" }}>Driver For Approval</span>
        <input
          type="text"
          placeholder="Search"
          value={globalFilter || ""}
          onChange={(e) => setGlobalFilter(e.target.value)}
          className="form-control form-control-sm"
          style={{ width: 140, height: 26, fontSize: 12 }}
        />
      </div>

      <div style={{ overflowX: "auto", marginBottom: 4 }}>
        <Table {...getTableProps()} size="sm" bordered hover style={{ fontSize: 12, minWidth: 1200 }}>
          <thead>
            {headerGroups.map((headerGroup, i) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={i}>
                {headerGroup.headers.map((col, j) => (
                  <th
                    {...col.getHeaderProps(col.disableSortBy ? {} : col.getSortByToggleProps())}
                    key={j}
                    style={{ padding: "4px 6px", fontSize: 11, fontWeight: 600, backgroundColor: "#E87B2D", color: "#fff" }}
                  >
                    {col.render("Header")}
                    {!col.disableSortBy && col.isSorted && <span style={{ marginLeft: 2 }}>{col.isSortedDesc ? "▼" : "▲"}</span>}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
          {page.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center py-3 text-muted" style={{ fontSize: 11 }}>No drivers found.</td>
            </tr>
          ) : (
            page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, j) => (
                    <td {...cell.getCellProps()} key={j} style={{ padding: "3px 6px", verticalAlign: "middle" }}>
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })
          )}
        </tbody>
        </Table>
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 11, flexWrap: "wrap", gap: 4 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>Page {pageIndex + 1} of {pageOptions.length || 1}</span>
          <select className="form-select form-select-sm" style={{ width: 50, height: 24, fontSize: 11 }} value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
            {[10, 15, 20, 30, 50].map((n) => <option key={n} value={n}>{n}</option>)}
          </select>
          <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-1" style={{ fontSize: 11 }} onClick={() => gotoPage(0)} disabled={!canPreviousPage}>|«</button>
          <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-1" style={{ fontSize: 11 }} onClick={() => previousPage()} disabled={!canPreviousPage}>‹</button>
          <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-1" style={{ fontSize: 11 }} onClick={() => nextPage()} disabled={!canNextPage}>›</button>
          <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-1" style={{ fontSize: 11 }} onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>»|</button>
        </div>
      </div>

      {/* Image preview modal */}
      <Modal
        show={imageModal.show}
        onHide={() => setImageModal({ show: false, url: "", label: "" })}
        fullscreen
        className="driver-doc-modal"
      >
        <Modal.Header closeButton className="bg-dark border-secondary">
          <Modal.Title className="text-white">{imageModal.label}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="d-flex align-items-center justify-content-center p-0 bg-dark overflow-auto"
          style={{ minHeight: "calc(100vh - 60px)" }}
        >
          {imageModal.url && (
            <img
              src={imageModal.url}
              alt={imageModal.label}
              style={{
                maxWidth: "100%",
                maxHeight: "calc(100vh - 60px)",
                width: "auto",
                height: "auto",
                objectFit: "contain",
              }}
              onError={(e) => {
                e.currentTarget.src = "";
                e.currentTarget.alt = "Image not found";
              }}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default DriverForApproval;
